export interface JSetting {
  positionMenuNav: string;
  positionInfoNav: string;
  hiddenInfoNav: boolean;
  btnType?: ButtonType | null;
}
export enum ButtonType {
  ICON = 1,
  TEXT = 2,
  TEXTANDICON = 3
}

export enum INzMessageType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning'
}
